
import { mapActions, mapGetters } from 'vuex';
import Vue from 'vue';
import { Adresse } from '@/model/adresse';
import { BrsTiers } from '@/model/brs-tiers';
import { PreferencesUtilisateur } from '@/model/preferences-utilisateur/preferences-utilisateur';
import { cloneDeep } from 'lodash';

export default Vue.extend({
  name: 'FicheTiers',
  computed: {
    ...mapGetters({ infoTiers: 'tiers/infosTiers', preferencesUtilisateur: 'preferenceUtilisateur/preferenceUtilisateur' }) as {
      infoTiers: () => BrsTiers,
      preferencesUtilisateur: () => PreferencesUtilisateur
    }
  },
  methods: {
    ...mapActions({ savePreferencesUtilisateur: 'preferenceUtilisateur/savePreferenceUtilisateur' }),
    adresseStr (adresse: Adresse): string {
      const adr1 = [adresse.ligneAdresse1?.trim(), adresse.ligneAdresse2?.trim(), adresse.ligneAdresse3?.trim()].filter(Boolean).join(', ');
      const adr2 = adresse.codePostal + ' ' + adresse.ville;
      return adr1 + (adr1 && adr2 ? ' - ' : '') + adr2;
    },
    isFavoriteAdresse (adresse: Adresse): boolean {
      return this.preferencesUtilisateur.adresseLivraisonFavorite && this.preferencesUtilisateur.adresseLivraisonFavorite === adresse.numAdr;
    },
    defineFavoriteAdresse (adresse: Adresse) {
      const newPrefUtilisateur = cloneDeep(this.preferencesUtilisateur);
      newPrefUtilisateur.adresseLivraisonFavorite = this.isFavoriteAdresse(adresse) ? null : adresse.numAdr;
      this.savePreferencesUtilisateur({ utilisateur: this.infoTiers.numTiers, preferenceUtilisateur: newPrefUtilisateur })
        .catch((error) => {
          // eslint-disable-next-line no-console
          console.error(error);
        });
    }

  }
});
